import "./Siteseeing.css";
export default function Sightseeing() {
  const sightseeingSpots = [
    {
      place: "Ooty",
      highlights: [
        "Botanical Garden",
        "Rose Garden",
        "Ooty Lake",
        "Doddabetta Peak",
        "Thread Garden",
        "St. Stephen's Church",
        "Government Museum",
        "Tea Factory & Museum",
        "Nilgiri Mountain Railway",
        "Karnataka Park",
      ],
      image:
        "https://images.hindustantimes.com/img/2023/01/11/1600x900/mugi-jo-6qUltw7SjzM-unsplash_1669276738103_1673425680248_1673425680248.jpg",
    },
    {
      place: "Coonoor",
      highlights: [
        "MRC Outer View Point",
        "Valley View Point",
        "Sim’s Park",
        "Lamb’s Rock",
        "Dolphin’s Nose",
        "Tea Estates",
        "Droog Fort",
        "Highfield Tea Factory",
        "Ralliah Dam",
        "Law's Falls",
      ],
      image:
        "https://tse2.mm.bing.net/th/id/OIP.RN1Bm0rpoQ8kq2yCbkIDrQHaDs?cb=12&rs=1&pid=ImgDetMain&o=7&rm=3",
    },
    {
      place: "Pykara",
      highlights: [
        "Pykara Lake",
        "Pykara Falls",
        "Shooting Point",
        "Boat House",
        "Forest Walk",
      ],
      image:
        "https://www.shutterstock.com/image-photo/pykara-waterfall-ooty-tamil-nadu-260nw-1732587470.jpg",
    },
    {
      place: "Mudumalai",
      highlights: ["Wildlife Safari", "Elephant Camp", "Theppakadu Forest"],
      image:
        "https://tse3.mm.bing.net/th/id/OIP.Y6e7LpYAqkTdm64YtYzANwHaEx?cb=12&rs=1&pid=ImgDetMain&o=7&rm=3",
    },
    {
      place: "Kothagiri",
      highlights: ["Catherine Falls", "Rangasamy Peak", "Longwood Shola"],
      image: "https://static.toiimg.com/photo/59104847/.jpg",
    },
    {
      place: "Avalanchi",
      highlights: [
        "Avalanchi Lake",
        "Upper Bhavani",
        "Eco-tourism Trek",
        "Emerald Lake",
      ],
      image:
        "https://i.pinimg.com/736x/6c/60/17/6c6017ac6a57e77b3dc08594b06b854e--ooty-india-coimbatore.jpg",
    },
  ];
  return (
    <>
      <div className="Sightseeing-Container" id="sightseeing">
        <h2 className="Sightseeing-Title">🗺️ Ooty Sightseeing by Cab</h2>
        <div className="Home_body">
          <div className="Home_video_container">
            <video
              src="https://ootygo-travel-partner.s3.ap-south-1.amazonaws.com/video_20241019_201338.mp4"
              muted
              autoPlay
              loop
              width="100%"
              className="Home_video"
              controlsList="nodownload"
            ></video>
          </div>
        </div>
        <div className="Sightseeing-Grid">
          {sightseeingSpots.map((spot, index) => (
            <div className="Sightseeing-Card" key={index}>
              <img
                src={spot.image}
                alt={spot.place}
                className="Sightseeing-Image"
              />
              <div className="Sightseeing-Content">
                <h3>{spot.place}</h3>
                <ul>
                  {spot.highlights.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
                <a
                  className="Sightseeing-Button"
                  href={`https://wa.me/919655062118?text=${encodeURIComponent(
                    `Hi, I'm interested in sightseeing around ${
                      spot.place
                    }. Can you share cab options and itinerary for: ${spot.highlights.join(
                      ", "
                    )}`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Book Cab
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
